import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';

/**
 * Renders a Markdown string to sanitized HTML. The marked output is passed
 * through Angular's HTML sanitizer here (defense in depth) so it is safe even
 * if a consumer binds it via a non-sanitizing context. Consumers still
 * typically bind it through `[innerHTML]`, which sanitizes again.
 */
@Pipe({ name: 'markdown', standalone: true })
export class MarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): string {
    if (!value) return '';
    const html = marked.parse(value, { async: false }) as string;
    return this.sanitizer.sanitize(SecurityContext.HTML, html) ?? '';
  }
}
